import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Alert, Snackbar } from '@mui/material';
import { getApiUrl } from '../config';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function About() {
  const [formData, setFormData] = useState({
    content: '',
    meta_title: '',
    meta_description: '',
    meta_keywords: ''
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    fetch(getApiUrl('/api/info/about'), {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
    })
    .then(res => {
      return res.json();
    })
    .then(data => {
      // اگر data یک array باشد
      if (data && Array.isArray(data) && data.length > 0) {
        setFormData(data[0]);
      }
      // اگر data یک object باشد (مستقیم)
      else if (data && typeof data === 'object' && !Array.isArray(data)) {
        setFormData(data);
      }
      // اگر data یک object با فیلدهای مختلف باشد
      else if (data && data.about) {
        setFormData(data.about);
      }
    })
    .catch(error => {
      console.error('Error fetching about info:', error);
      setSnackbar({ open: true, message: 'خطا در دریافت اطلاعات درباره ما', severity: 'error' });
    });
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const res = await fetch(getApiUrl('/api/info/about'), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        setSnackbar({ open: true, message: 'اطلاعات درباره ما با موفقیت ذخیره شد', severity: 'success' });
      } else {
        setSnackbar({ open: true, message: 'خطا در ذخیره اطلاعات درباره ما', severity: 'error' });
      }
    } catch (error) {
      console.error('Error saving about info:', error);
      setSnackbar({ open: true, message: 'خطا در ذخیره اطلاعات درباره ما', severity: 'error' });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Box sx={{ p: 3, fontFamily: 'Vazir' }}>
      <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>
        اطلاعات درباره ما
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 800 }}>


        <Box sx={{ mt: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontFamily: 'Vazir' }}>
            محتوا *
          </Typography>
          <ReactQuill
            value={formData.content}
            onChange={(value) => setFormData({ ...formData, content: value })}
            theme="snow"
            style={{ height: '300px', marginBottom: '50px', fontFamily: 'Vazir' }}
            modules={{
              toolbar: [
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'align': [] }],
                ['link', 'image'],
                ['clean']
              ]
            }}
          />
        </Box>

        <TextField
          fullWidth
          label="عنوان SEO"
          name="meta_title"
          value={formData.meta_title}
          onChange={handleChange}
          margin="normal"
          sx={{ fontFamily: 'Vazir' }}
          inputProps={{ style: { fontFamily: 'Vazir' } }}
        />

        <TextField
          fullWidth
          label="توضیحات SEO"
          name="meta_description"
          value={formData.meta_description}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={3}
          sx={{ fontFamily: 'Vazir' }}
          inputProps={{ style: { fontFamily: 'Vazir' } }}
        />

        <TextField
          fullWidth
          label="کلمات کلیدی SEO"
          name="meta_keywords"
          value={formData.meta_keywords}
          onChange={handleChange}
          margin="normal"
          sx={{ fontFamily: 'Vazir' }}
          inputProps={{ style: { fontFamily: 'Vazir' } }}
        />

        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 3, fontFamily: 'Vazir', fontWeight: 'bold' }}
        >
          ذخیره اطلاعات
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })} sx={{ fontFamily: 'Vazir' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default About; 